// AboutUs.js
import React from 'react';
import './../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div id='aboutUsContainer'>
      <h1 id='title'>About The Ministry</h1>
      <p id='aboutText'>
        Why God Ministries was established with the intention of applying science-based,
        rational and logical thought, and the sharing of real-world examples that provide
        compelling evidence proving that the Bible is true, and that the God of the Bible is real.
      </p>
    </div>
  );
};

export default AboutUs;